import React from 'react';
import Error from './Error';

function NotFoundComponent() {
  return <Error />;
}

export default NotFoundComponent;
